import * as types from './types';

const INITIAL_STATE = {
  itemColors: [],
  fetchError: null,
  fetching: false,
  success: 0,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.COLOR_FETCH:
      return {
        ...state,
        itemColors: payload.data.Data,
      };

    case types.COLOR_FETCHING:
      return { ...state, fetching: payload };

    case types.COLOR_FETCH_ERROR:
      return { ...state, fetchError: payload };

    case types.COLOR_SET_SUCCESS:
      return {
        ...state,
        success: state.fetchError === null ? 1 : 0,
      };

    case types.COLOR_RESET_SUCCESS:
      return {
        ...state,
        success: 0,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/state/colorsetup/reducer.js